import React from 'react';

import { useAppSelector } from '../../../../components/hooks';
import { isLayoutBasedOnRoofContainers } from '../../../../store/selectors/layoutModeSelectors';
import { getActiveEnvelopeMode } from '../../../../store/selectors/layoutVisualOptionsSelectors';
import { FeaturePatternRunDimensionsController } from './FeaturePatternRunDimensionsController';
import { RoofContainersRunDimensionsController } from './RoofContainersRunDimensionsController';
import { RoofPlaneEnvelopesRunDimensionsController } from './RoofPlaneEnvelopesRunDimensionsController';

export function AutomaticRunDimensionsController() {
  const showRunDimensions = useAppSelector((state) => state.visualOptions.showRunDimensionsInLayout);
  const envelopesHiddenByMode = useAppSelector((state) => getActiveEnvelopeMode(state) === 'none');

  const inRoofContainerLayout = useAppSelector(isLayoutBasedOnRoofContainers);

  if (!showRunDimensions || envelopesHiddenByMode) return null;

  return (
    <>
      <FeaturePatternRunDimensionsController />

      {inRoofContainerLayout ? (
        <RoofContainersRunDimensionsController />
      ) : (
        <RoofPlaneEnvelopesRunDimensionsController />
      )}
    </>
  );
}
